import useRequest from "../useRequest";

export const useSubscriptionDetails = (id?: string | null) => {
  const url = `/news-letter-subscriptions/${id}`;
  const { data, ...rest } = useRequest(!!id ? url : null, url);
  return {
    data: data as any,
    ...rest,
  };
};
